import { defineStore, acceptHMRUpdate } from 'pinia'
import { computed } from 'vue'
import { useAccountQuery } from 'src/composables/account/query/useAccountQuery'
import { themeService } from 'src/services/app/theme.service'
import { THEME } from 'src/services/consts/app.const'

export const useAccountStore = defineStore('account', () => {
  // AppState
  const accountQuery = useAccountQuery()

  const accountData = computed(() => accountQuery.accountData.value)
  const accountId = computed(() => accountQuery.accountIdType.value?.accountId)
  const aimgmtUrl = computed(() => accountQuery.accountIdType.value?.servers?.aimgmt || null)
  const isAdmin = computed(() => !!aimgmtUrl.value)
  const newTicketQuestions = computed(
    () => accountQuery.accountData.value?.newTicketQuestions || []
  )

  // Theme lives on account settings. Falls back to the locally cached value while account
  // data is in flight, and for as long as the server has no stored theme — otherwise a load
  // would clobber the user's current choice.
  const theme = computed(() => accountData.value?.settings?.theme ?? themeService.getCachedTheme())
  const isDark = computed(() => theme.value === THEME.DARK)
  const showContactSupport = computed(() => !!accountData.value?.settings?.showContactSupport)
  // True until the employee finishes the onboarding walkthrough once; the backend keeps it.
  const showOnboardingTour = computed(() => !!accountData.value?.settings?.showOnboardingTour)

  return {
    accountData,
    accountId,
    aimgmtUrl,
    isAdmin,
    newTicketQuestions,
    theme,
    isDark,
    showContactSupport,
    showOnboardingTour,
    isLoading: accountQuery.isLoading,
    isRefetching: accountQuery.isRefetching,
    error: accountQuery.error,
    refetch: accountQuery.refetch,
    updateAccountTickets: accountQuery.updateAccountTickets,
    updateAccountApprovals: accountQuery.updateAccountApprovals,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountStore, import.meta.hot))
}
